import type { RolePermission } from "@/domain/dto/role-permission.dto";
import type {  SecurityRole } from "@/domain/dto/security-role.dto";

process.env.NODE_TLS_REJECT_UNAUTHORIZED = "1"; // ⚠️ Solo usar en desarrollo para evitar errores SSL

const apiUrl = process.env.NEXT_PUBLIC_API_URL || "https://localhost:7061";
export const ROLES_API_ENDPOINT = `${apiUrl}/api/v1.0/security/roles`;
export const ROLES_PERMISSION_API_ENDPOINT = `${apiUrl}/api/v1.0/security/roles-permissions`;
// export const USER_ROLES_PERMISSION_API_ENDPOINT = `${apiUrl}/api/v1.0/security/user/{userId}/permissions`;
export const CREATE_ROLE_API_ENDPOINT = `${apiUrl}/api/v1.0/business/role`;
export const CREATE_ROLE_PERMISSIONS_API_ENDPOINT = `${apiUrl}/api/v1.0/business/role-permissions`;

export const fetchRoles = async (): Promise<SecurityRole[]> => {
    try {
        const response = await fetch(ROLES_API_ENDPOINT, {
            // cache: "no-store",
            next: { revalidate: 600 }, // 🔄 Mantiene los datos en caché por 10 min
        });

        if (!response.ok) {
            throw new Error(`Error fetching roles: ${response.statusText}`);
        }

        return response.json();
    } catch (error) {
        console.error("Fetch error (roles):", error);
        return [];
    }
};

export const fetchRolesPermissions = async (): Promise<RolePermission[]> => {
    try {
        const response = await fetch(ROLES_PERMISSION_API_ENDPOINT, {
            // cache: "no-store",
            next: { revalidate: 600 }, // 🔄 Mantiene los datos en caché por 10 min
        });

        if (!response.ok) {
            throw new Error(`Error fetching roles: ${response.statusText}`);
        }

        return response.json();
    } catch (error) {
        console.error("Fetch error (roles):", error);
        return [];
    }
};

// export const fetchUserRolesPermissions = async (userId: number): Promise<RolePermission[]> => {
//     try {
//         const url = USER_ROLES_PERMISSION_API_ENDPOINT.replace("{userId}", userId.toString())
//         const response = await fetch(url, {
//             // cache: "no-store",
//             next: { revalidate: 60 }, // 🔄 Mantiene los datos en caché por 10 min
//         });

//         if (!response.ok) {
//             throw new Error(`Error fetching users permissions: ${response.statusText}`);
//         }

//         return response.json();
//     } catch (error) {
//         console.error("Fetch error (users permissions):", error);
//         return [];
//     }
// };

export const createRole = async (roleData?: RolePermission | null) => {
    const response = await fetch(CREATE_ROLE_PERMISSIONS_API_ENDPOINT, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(roleData),
    });

    // console.log(JSON.stringify(roleData));

    if (!response.ok) {
        const errorResponse = await response.json();
        const errorMessage = errorResponse.message || "Error desconocido";

        // Lanza un error para que sea gestionado en el componente
        throw new Error(errorMessage);
    }

    // Retorna los datos si la creación fue exitosa
    return await response.json();
};
